import { useAuth } from '@/auth/auth-provider'
import loginBackground from '@/assets/images/login_background.jpg'
import {
    Alert,
    Box,
    Button,
    Group,
    Paper,
    Stack,
    Text,
    Title
} from '@mantine/core'
import { IconAlertTriangle, IconArrowLeft, IconShieldX } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'

export const UnauthorizedPage = () => {
  const { signOut } = useAuth()
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleLogout = () => {
    signOut()
  }

  return (
    <Box 
      h="100vh" 
      w="100%"
      pos="relative"
      style={{ 
        backgroundImage: `url(${loginBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        filter: 'brightness(0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {/* Overlay gradient */}
      <Box
        pos="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        style={{
          background: 'linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(200,0,0,0.3) 100%)',
        }}
      />

      <Box w={420} pos="relative" style={{ zIndex: 2 }}>
          <Paper shadow="xl" radius="md" p="xl" withBorder>
            <Stack gap="lg" ta="center">
              {/* Icon */}
              <Box>
                <IconShieldX size={80} color="#dc2626" />
              </Box>

              {/* Title */}
              <Box>
                <Title order={2} c="dark">
                  Access Denied
                </Title>
                <Text c="dimmed" size="sm" mt="xs">
                  You don't have permission to access this resource
                </Text>
              </Box>

              {/* Alert */}
              <Alert
                icon={<IconAlertTriangle size={16} />}
                title="Insufficient Permissions"
                color="red"
                variant="light"
              >
                Your account doesn't have access to the requested dealership or dealership group. 
                Please contact your administrator if you believe this is an error.
              </Alert>

              {/* Actions */}
              <Stack gap="md">
                <Group grow>
                  <Button
                    variant="outline"
                    leftSection={<IconArrowLeft size={16} />}
                    onClick={handleGoBack}
                  >
                    Go Back
                  </Button>
                  <Button
                    color="red"
                    onClick={handleLogout}
                  >
                    Sign Out
                  </Button>
                </Group>
              </Stack>

              {/* Footer */}
              <Box>
                <Text size="xs" c="dimmed">
                  Need help? Contact your system administrator
                </Text>
              </Box>
            </Stack>
          </Paper>
        </Box>
    </Box>
  )
}
